import { RedirectLoginOptions as BaseRedirectLoginOptions } from '@auth0/auth0-react';
import { useCallback } from 'react';

import { useAppDependenciesContext } from '../../state';
import { loginExperienceAuthorizationParams } from '../types';
import { CustomRedirectUrlQueryParams, getRedirectUrl, setCustomRedirectUrlQueryParams } from './redirectUrl';

export interface LoginWithRedirectCallbackOptions
  extends Omit<BaseRedirectLoginOptions, 'appState' | 'authorizationParams'>,
    CustomRedirectUrlQueryParams {
  appState?: Omit<BaseRedirectLoginOptions['appState'], 'returnTo'>;
  authorizationParams?: Omit<
    BaseRedirectLoginOptions['authorizationParams'],
    'target_login_experience' | 'ext-target_login_experience' | 'redirect_uri'
  >;
  // Optional origin to use for the redirect URL, useful for testing purposes.
  // If not provided, defaults to the current origin.
  origin?: string;
}

export function useLoginWithRedirectCallback() {
  const { useAuth0 } = useAppDependenciesContext();
  const { loginWithRedirect } = useAuth0();

  return useCallback(
    ({
      returnTo,
      loginExperience,
      appState,
      authorizationParams,
      origin: givenOrigin,
      ...passThroughOptions
    }: LoginWithRedirectCallbackOptions) => {
      const redirectUrlWithQueryParams = setCustomRedirectUrlQueryParams(getRedirectUrl(givenOrigin), {
        returnTo,
        loginExperience,
      });
      loginWithRedirect({
        ...passThroughOptions,
        appState: { ...appState, returnTo, loginExperience },
        authorizationParams: {
          ...authorizationParams,
          redirect_uri: redirectUrlWithQueryParams,
          ...loginExperienceAuthorizationParams(loginExperience),
        },
      });
    },
    [loginWithRedirect],
  );
}
